<section class="mobile-nav-container" tabindex="0" (keydown.escape)="closeSidenav()">
  <!--MOBILE NAV CONTAINER-->
  <div>
    <div class="mobile-logo-container">
      @if (isEpi && (isAuthenticated$ | async) !== true) {
        <a id="mobileLogoLink" mat-button rdcAnalyticsData="home" [href]="homeUrl">
          <img
            id="mobile-logo-not-authenticated"
            alt="RIDE COMMAND® Logo"
            [ngSrc]="`/assets/images/${brand}/logo${isEpi ? '-epi.png' : '.svg'}`"
            i18n-alt
          />
        </a>
      }
      @if (!isEpi || (isEpi && (isAuthenticated$ | async))) {
        <a id="mobileLogoLink" href="javascript:void(0)" routerLink="/home" mat-button rdcAnalyticsData="home">
          <img
            id="mobile-logo-not-authenticated"
            alt="RIDE COMMAND® Logo"
            [ngSrc]="`/assets/images/${brand}/logo${isEpi ? '-epi.png' : '.svg'}`"
            i18n-alt
          />
        </a>
      }
    </div>
    <div class="nav-mobile-secondary-container">
      <ul class="list-unstyled">
        @if (!isEpi && isOffRoad && (isAuthenticated$ | async)) {
          <li class="hide-for-motorcycle" mat-button>
            <a
              id="mobileTrailManagerLink"
              href="javascript:void(0)"
              routerLink="/map-edit"
              (click)="closeSidenav()"
              i18n
              >Club/Trail Manager</a
            >
          </li>
        }
        <li>
          @if (isEpi) {
            <a id="mobileSupportLink" mat-button [href]="supportUrl" (click)="closeSidenav()" i18n>Support</a>
          } @else {
            <a
              id="mobileSupportLink"
              href="javascript:void(0)"
              routerLink="/support"
              mat-button
              (click)="closeSidenav()"
              i18n
              >Support</a
            >
          }
        </li>
        @if (!isEpi && (isAuthenticated$ | async)) {
          <div>
            <li>
              <a
                id="mobileProfileLink"
                href="javascript:void(0)"
                routerLink="/account/profile"
                mat-button
                (click)="closeSidenav()"
                i18n
                >Profile</a
              >
            </li>
            <li>
              <a
                id="mobileSettingsLink"
                href="javascript:void(0)"
                routerLink="/account/settings"
                mat-button
                (click)="closeSidenav()"
                i18n
                >Settings</a
              >
            </li>
            <li>
              <a id="mobileAddVehicleLink" href="javascript:void(0)" mat-button (click)="addVehicle()">
                @if (isIndian) {
                  <span class="add-bike" i18n>Add Bike</span>
                } @else {
                  <span class="add-vehicle" i18n>Add Vehicle</span>
                }
              </a>
            </li>
            <li>
              <a id="mobileLogoutLink" href="javascript:void(0)" mat-button (click)="logOut(); closeSidenav()" i18n
                >Log Out</a
              >
            </li>
          </div>
        }
        @if (!isEpi && (isAuthenticated$ | async) === false) {
          <div>
            <li>
              <a id="mobileSignupLink" href="javascript:void(0);" mat-button (click)="signUp(); closeSidenav()" i18n
                >Create Account</a
              >
            </li>
            <li>
              <a id="mobileLoginLink" href="javascript:void(0);" mat-button (click)="logIn(); closeSidenav()" i18n
                >Log In</a
              >
            </li>
          </div>
        }
      </ul>
    </div>
  </div>
</section>
